<template>
    <b-card header="Manager Assignment">
      <b-row>
        <b-col cols="12" md="12">
          <b-button type="button" variant="primary" style="float:left; margin-left:5px;margin-right:5px;" @click="assignSelected($event.target)">
            <i class="fa fa-plus-circle"></i>
            Assign to manager
          </b-button>
          <b-button type="button" variant="danger" style="float:left; margin-left:5px;margin-right:5px;" @click="clearAll">
            <i class="fa fa-eraser"></i>
            Clear selections
          </b-button>

        </b-col>

    </b-row>
      <b-row>
        <b-col cols="12" md="4">
          <div class="alert alert-success" role="alert" style="margin-bottom:0px; margin-top: 10px;">
            <input type="checkbox" v-model="selectedLocation" @click="selectLocation"> Assign current location
          </div>
        </b-col>
        <b-col cols="12" md="4">
          <div class="alert alert-success" role="alert" style="margin-bottom:0px; margin-top: 10px;">
            <input type="checkbox" v-model="selectAllLockgroup" @click="selectAllLG"> Select all lockgroup</input>
          </div>
        </b-col>
        <b-col cols="12" md="4">
          <div class="alert alert-success" role="alert" style="margin-bottom:0px; margin-top: 10px;">
            <input type="checkbox" v-model="selectAllLock" @click="selectAllLocks"> Select all locks</input>
          </div>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="12" md="4">
          <!-- <b-form-group label="" v-model="selectAllLockgroup"> -->
            <!-- <b-form-checkbox-group stacked v-model="selectedLocation" :plain="false" name="location" :options="this.locations">
            </b-form-checkbox-group> -->
          <!-- </b-form-group> -->
        </b-col>

        <b-col cols="12" md="4">
          <b-form-group label="" v-model="selectAllLockgroup">
            <b-form-checkbox-group stacked v-model="selectedLockGroups" :plain="false" name="lockgroup" :options="lockgroups"  >
            </b-form-checkbox-group>
          </b-form-group>
        </b-col>

        <b-col cols="12" md="4">
          <b-form-group label="" v-model="selectAllLockgroup">
            <b-form-checkbox-group stacked v-model="selectedLocks" :plain="false" name="lock" :options="locks">
            </b-form-checkbox-group>
          </b-form-group>
        </b-col>
      </b-row>

    </b-card>
</template>

<script>
let qs = require('qs')
const constants = require('../shared/constants')
const BASE = constants.NEWPORT_CONST.API_URL
const API = BASE + '/api/lockManagerMappers/listForManager'
// const API_DELETE = BASE + '/api/lockManagerMappers/delete'
const API_LIST_LOCKGROUP = BASE + '/api/lockgroups/list'
// const API_ADD_MANAGER_LOCKGROUPMAPPER = BASE + '/api/lockManagerMappers/addLockGroup'
const API_ADD_BULK_LOCKGROUPS_MANAGER_LOCKGROUPMAPPER = BASE + '/api/lockManagerMappers/addLockGroups'
const API_ADD_BULK_LOCKS_MANAGER_LOCKGROUPMAPPER = BASE + '/api/lockManagerMappers/addLocks'
const API_LIST_LOCATION = BASE + '/api/locations/list'
//const API_LOCATION_DETAIL = BASE + '/api/locations/detail'
//const API_LIST_LOCKS = BASE + '/api/locks/list'
const API_ASSIGN_TO_LOCATION = BASE + '/api/lockManagerMappers/addLocation'
const API_REMOVE_FROM_LOCATION = BASE + '/api/lockManagerMappers/removeLocation'
const API_LIST_MANAGERS = BASE + '/api/lockManagers/list'

function postdata (url, data) {
  return fetch(url, {
    body: qs.stringify(data),
    headers: {
      'content-type': 'application/x-www-form-urlencoded',
      'accessToken': data.accessToken,
      'authorization': data.accessToken
    },
    method: 'POST'
  })
    .then(res => res.json())
}

async function getManagers () {
  let parameters = {
    client_id: constants.NEWPORT_CONST.CLIENT_ID,
    client_secret: constants.NEWPORT_CONST.CLIENT_SECRET,
    accessToken: localStorage.getItem('token')
  }
  let res = await postdata(API_LIST_MANAGERS, parameters)
  return res.lockManagers
}

async function getData (managerId) {
  let parameters = {
    client_id: constants.NEWPORT_CONST.CLIENT_ID,
    client_secret: constants.NEWPORT_CONST.CLIENT_SECRET,
    accessToken: localStorage.getItem('token'),
    managerId: managerId
  }
  let res = await postdata(API, parameters)
  return res.lockManagerList
}

// async function getLocks () {
//   let parameters = {
//     client_id: constants.NEWPORT_CONST.CLIENT_ID,
//     client_secret: constants.NEWPORT_CONST.CLIENT_SECRET,
//     accessToken: localStorage.getItem('token'),
//     locationId: localStorage.getItem('locationId')
//   }
//   let res = await postdata(API_LIST_LOCKS, parameters)
//   if (res.locks) {
//     let result = []
//     for (var i in res.locks) {
//       let lock = res.locks[i]
//       let checkboxData = {
//         text: lock.lockName + ' | ' + lock.lockAlias,
//         value: lock.id
//       }
//       result.push(checkboxData)
//     }
//     return result
//   }
// }

async function getLockgroups (mapper) {
  let parameters = {
    client_id: constants.NEWPORT_CONST.CLIENT_ID,
    client_secret: constants.NEWPORT_CONST.CLIENT_SECRET,
    accessToken: localStorage.getItem('token'),
    locationId: localStorage.getItem('locationId')
  }
  let res = await postdata(API_LIST_LOCKGROUP, parameters)
  if (res.lockGroups.length > 0) {
    let result = []
    for (var i in res.lockGroups) {
      let lg = res.lockGroups[i]
      let checkboxData = {
        text: lg.location.name + ' | ' + lg.name,
        value: lg.id
      }
      result.push(checkboxData)
    }
    return result
  }
}

async function getLocations () {
  let parameters = {
    client_id: constants.NEWPORT_CONST.CLIENT_ID,
    client_secret: constants.NEWPORT_CONST.CLIENT_SECRET,
    accessToken: localStorage.getItem('token')
  }
  let res = await postdata(API_LIST_LOCATION, parameters)
  if (res.locations.length > 0) {
    let result = []
    for (var i in res.locations) {
      let loc = res.locations[i]
      let checkboxData = {
        text: loc.name,
        value: loc.id
      }
      result.push(checkboxData)
    }
    return result
  }
}

// async function getLocation () {
//   let parameters = {
//     client_id: constants.NEWPORT_CONST.CLIENT_ID,
//     client_secret: constants.NEWPORT_CONST.CLIENT_SECRET,
//     accessToken: localStorage.getItem('token'),
//     locationId: localStorage.getItem('locationId')
//   }
//   let res = await postdata(API_LOCATION_DETAIL, parameters)
//   let result = []
//   if (res.location) {
//     let checkboxData = {
//       text: res.location.name,
//       value: res.location.id
//     }
//     result.push(checkboxData)
//   }
//   return result
// }

async function addManagerToLockGroups (managerId, lockGroups) {
  let parameters = {
    client_id: constants.NEWPORT_CONST.CLIENT_ID,
    client_secret: constants.NEWPORT_CONST.CLIENT_SECRET,
    accessToken: localStorage.getItem('token'),
    lockManagerId: managerId,
    lockGroups: lockGroups,
    locationId: localStorage.getItem('locationId')
  }
  let res = await postdata(API_ADD_BULK_LOCKGROUPS_MANAGER_LOCKGROUPMAPPER, parameters)
  return res
}

async function addManagerToLocks (managerId, locks) {
  let parameters = {
    client_id: constants.NEWPORT_CONST.CLIENT_ID,
    client_secret: constants.NEWPORT_CONST.CLIENT_SECRET,
    accessToken: localStorage.getItem('token'),
    lockManagerId: managerId,
    locks: locks
  }
  let res = await postdata(API_ADD_BULK_LOCKS_MANAGER_LOCKGROUPMAPPER, parameters)
  return res
}

async function assignManagerToLocation (managerId, location) {
  let parameters = {
    client_id: constants.NEWPORT_CONST.CLIENT_ID,
    client_secret: constants.NEWPORT_CONST.CLIENT_SECRET,
    accessToken: localStorage.getItem('token'),
    locationId: localStorage.getItem('locationId'),
    lockManagerId: managerId
  }
  let URL = null
  if (location) {
    URL = API_ASSIGN_TO_LOCATION
  } else {
    URL = API_REMOVE_FROM_LOCATION
  }
  let res = await postdata(URL, parameters)
  return res
}

export default {
  name: 'manager-assign',
  props: ['locationName', 'locationDescription', 'managerId', 'modalId'],
  data: () => {
    return {
      selectedLocation: 0,
      selectedLockGroups: [],
      selectedLocks: [],
      selectAllLocation: false,
      selectAllLockgroup: false,
      selectAllLock: false,
      lockmanagersmapper: [],
      lockgroups: [],
      locations: [],
      locks: [],
      fields: {
        location: {
          label: 'Location'
        },
        lockGroup: {
          label: 'LockGroup'
        },
        action: {
          label: 'Action'
        }
      },
      fieldsLockgroup: {
        location: {
          label: 'Location'
        },
        lockgroup: {
          label: 'Lock Group'
        },
        action: {
          label: 'Action'
        }
      },
      fieldsLocation: {
        check: {
          label: 'Select'
        },
        name: {
          label: 'Name'
        },
        action: {
          label: 'Action'
        }
      },
      currentPage: 1,
      perPage: 15,
      totalRows: 0,
      filter: null
    }
  },
  mounted () {
    getData(this.managerId).then(response => {
      this.$data.lockmanagersmapper = response
      for (var i in response) {
        let lmm = response[i]
        if (lmm.lockGroupId != null && lmm.lockGroupId > 0) {
          this.$data.selectedLockGroups.push(lmm.lockGroupId)
        }
        if (lmm.lockId != null && lmm.lockId > 0) {
          this.$data.selectedLocks.push(lmm.lockId)
        }
        if (lmm.lockId == null && lmm.lockGroupId == null && lmm.locationId > 0) {
          this.$data.selectedLocation = lmm.locationId
        }
      }
    })
    getLockgroups().then(response => {
      this.$data.lockgroups = response
    })
   this.getLocalLocationDetail()

    // getLocks().then(response => {
    //   this.$data.locks = response
    // })

    let localLocksList = localStorage.getItem('localLocksList')
    let localLocationIds = localStorage.getItem('locationId')

      if(localLocksList === null || localLocksList === 'undefined') {
        constants.gotoLogin("ManagerAssign")
      } else {
        localLocksList = JSON.parse(localLocksList)
        this.$data.locks = []
        for(let i in localLocksList) {
          let loopLocations = localLocksList[i]
          if(localLocationIds == loopLocations.locationId) {
            let checkboxDatas = {
              text: loopLocations.lockName + ' | ' + loopLocations.lockAlias,
              value: loopLocations.id
            }
            this.$data.locks.push(checkboxDatas)
          }
        }
      }
  },
  methods: {
    mailto (email) {
      return 'mailto:' + email
    },
    getLocalLocationDetail() {
      let localLocationList = localStorage.getItem('localLocationsList')
      let localLocationId = localStorage.getItem('locationId')

      if(localLocationList === null || localLocationList === 'undefined') {
        constants.gotoLogin()
      } else {
        localLocationList = JSON.parse(localLocationList)
        for(let i in localLocationList) {
          let loopLocation = localLocationList[i]
          if(localLocationId === loopLocation.id) {
            // this.$data.locations.push(loopLocation)
            let checkboxData = {
              text: loopLocation.name,
              value: loopLocation.id
            }
            this.$data.locations.push(checkboxData)
            return loopLocation
          }
        }
        return null
      }
    },



    modalDeleteMapperId (i) {
      var anId = 'modaldeletemanagermapper' + i
      return anId
    },
    getRowCount (items) {
      return items.length
    },
    openlink (link) {
      location.href = link
    },
    selectAllLoc () {
      this.selectedLocation = []
      if (!this.selectAllLocation) {
        let locs = this.locations
        for (var i in locs) {
          let loc = locs[i]
          this.selectedLocation.push(loc.value)
        }
      }
    },
    selectAllLG () {
      this.selectedLockGroups = []
      if (!this.selectAllLockgroup) {
        let lgs = this.lockgroups
        for (var i in lgs) {
          let lg = lgs[i]
          this.selectedLockGroups.push(lg.value)
        }
      }
    },
    selectAllLocks () {
      this.$data.selectedLocks = []
      if (!this.$data.selectAllLock) {
        let locks = this.$data.locks
        for (var i in locks) {
          let lg = locks[i]
          this.selectedLocks.push(lg.value)
        }
      }
    },
    assignToLocation (button) {
      assignManagerToLocation(this.managerId, this.selectedLocation).then(response => {
        this.$root.$emit('bv::hide::modal', this.modalId, button)
      })
    },
    clearAll () {
      this.selectedLocks = []
      this.selectedLockGroups = []
      this.selectAllLockgroup = false
      this.selectAllLock = false
    },
    assignSelected (button) {
      if (this.selectedLocks.length == 0 && this.selectedLockGroups.length == 0 && this.selectedLocation.length == 0) {
        alert('Please select location or lockgroup or lock to complete assignment.')
      } else {
        assignManagerToLocation(this.managerId, this.selectedLocation).then(response => {
        })
        if (!this.selectedLocation) {
          addManagerToLocks(this.managerId, this.selectedLocks).then(response => {
          })
          addManagerToLockGroups(this.managerId, this.selectedLockGroups).then(response => {
          })
        }
        getManagers().then(dataList => {
          this.$root.$emit('managers', dataList)
          this.$root.$emit('bv::hide::modal', this.modalId, button)
        })
      }
    },
    selectLocation () {
      if (!this.selectedLocation) {
        this.selectAllLG()
        this.selectAllLocks()
      } else {
        this.selectedLockGroups = []
        this.selectedLocks = []
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/base/haus/ManagerAssign.vue